import React, { useState } from "react";

function ContactForm() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Our team will contact you shortly.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <section className="contact" id="contact">

      <div className="contact-wrapper">

       
        {/* Contact Details */}
        <div className="contact-info">
          <h2>Contact Details</h2>

          <p><strong>Address:</strong><br/>
          Residency Club MIDC Latur<br/>
          MIDC Area, Latur, Maharashtra</p>

         <p>
  <strong>Phone:</strong><br/>
  <a href="tel:+918275055590" className="phone-link">+91 8275055590</a> | 
  <a href="tel:+919422071672" className="phone-link"> +91 9422071672</a>
</p>

          {/* <p><strong>Email:</strong><br/>
          info@rcml.com</p> */}

          <h3>Location</h3>

          <iframe
            title="map"
            src="https://www.google.com/maps?q=latur%20midc&output=embed"
            width="70%"
            height="150"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>

        </div>
 {/* Contact Form */}
        <div className="contact-form">
          <h2>Send Us a Message</h2>

          <form onSubmit={handleSubmit}>

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              rows="5"
              placeholder="Write your message..."
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <button type="submit" className="btn">
              Send Request
            </button>

          </form>
        </div>

      </div>

    </section>
  );
}

export default ContactForm;